import { UserOutlined } from '@ant-design/icons';
import { Species, UserPrivate } from '@omniafishing/core';
import { Checkbox, Form, Input, Radio } from 'antd';
import { CheckboxOptionType } from 'antd/lib/checkbox';
import { FormInstance } from 'antd/lib/form';
import React from 'react';
import styles from './waterbody_activation_request_form.less';

export interface WaterbodyActivationRequestFormProps {
  species: Species[];
  user: UserPrivate;
  formRef: React.RefObject<FormInstance>;
}

export const WaterbodyActivationRequestForm: React.FC<WaterbodyActivationRequestFormProps> = (
  props
) => {
  const formFields = {
    email: 'email',
    species: 'species',
    description: 'description',
    clarity: 'clarity',
  };

  const { user, species, formRef } = props;

  function SpeciesOptions(): CheckboxOptionType[] {
    return species
      .filter((specie) => specie.display_order != null)
      .map((specie) => {
        return {
          label: specie.display_name,
          value: specie.name,
        };
      });
  }

  return (
    <Form ref={formRef} layout="vertical">
      {user == null && (
        <Form.Item
          name={formFields.email}
          rules={[{ required: true, message: 'Please input your email' }]}
        >
          <fieldset>
            <legend>Email address:</legend>
            <Input
              prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Email"
              type="email"
            />
          </fieldset>
        </Form.Item>
      )}
      <Form.Item
        name={formFields.species}
        rules={[{ required: true, message: 'Please choose species' }]}
      >
        <fieldset>
          <legend>Species you fish for in this waterbody:</legend>
          <Checkbox.Group
            options={SpeciesOptions()}
            style={{
              width: '100%',
              columnCount: 2,
              textTransform: 'capitalize',
            }}
            className={styles.checkboxes}
          />
        </fieldset>
      </Form.Item>

      <Form.Item name={formFields.clarity} label="Water Clarity" className={styles.clarity}>
        <Radio.Group className={styles.clarityRadios}>
          <Radio.Button value="0">0</Radio.Button>
          <Radio.Button value="1">1</Radio.Button>
          <Radio.Button value="2">2</Radio.Button>
          <Radio.Button value="3">3</Radio.Button>
          <Radio.Button value="4">4</Radio.Button>
          <Radio.Button value="5">5</Radio.Button>
          <Radio.Button value="6">6</Radio.Button>
          <Radio.Button value="7">7</Radio.Button>
          <Radio.Button value="8">8</Radio.Button>
          <Radio.Button value="9">9</Radio.Button>
          <Radio.Button value="10">10</Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Form.Item name={formFields.description} label="Description" className={styles.description}>
        <Input.TextArea rows={3} />
      </Form.Item>
    </Form>
  );
};
